import { ElMessage, ElNotification } from 'element-plus'
import type { Appointment } from '~/models/appointments'
import type { ContainerType, ShippingLine } from '~/services/apiClient'
import { AppointmentBookingApi } from '~/services/apiClient'
import { useContainerTypesStore } from '~/stores/containerTypes'

interface UseSwapEmptyActionsProps {
  appointment: Appointment
  form: {
    empty_container_number: string
    shipping_line?: ShippingLine
    container_type?: ContainerType
    chassis_number: string | null
  }
  validateForm: () => Promise<boolean>
  validateEmptyContainer: () => Promise<void>
}

export function useSwapEmptyActions(props: UseSwapEmptyActionsProps) {
  const containerTypeStore = useContainerTypesStore()

  async function swapEmpty(): Promise<boolean> {
    const api = new AppointmentBookingApi()
    if (!props.appointment.is_empty_in) {
      ElMessage.warning(
        'Swap empty is not supported for this appointment. Must be an empty in appointment'
      )
      return false
    }
    const currentTerminal = props.appointment.terminal
    if (!currentTerminal) {
      return false
    }
    try {
      await api.editAppointmentSwapEmptyAppointmentsBookingSwapEmptyPost({
        appointment_id: props.appointment.id,
        empty_container_number: props.form.empty_container_number,
        shipping_line: props.form.shipping_line!,
        container_type: props.form.container_type!,
        chassis_number: props.form.chassis_number || undefined,
      })
      ElNotification.success({ title: 'Swap empty started' })
      return true
    } catch (error) {
      return false
    }
  }

  async function submitForm(): Promise<boolean> {
    const isValid = await props.validateForm()
    if (isValid) {
      return await swapEmpty()
    }
    return false
  }

  function initialize() {
    containerTypeStore.loadContainerTypes()
    if (props.form.empty_container_number) {
      props.validateEmptyContainer()
    }
  }

  return {
    swapEmpty,
    submitForm,
    initialize,
  }
}
